import hasPreAccessEnded from './hasPreAccessEnded';
import isPreAccessProduct from './isPreAccessProduct';
import isProductEnabledForUserGroup from './isProductEnabledForUserGroup';
const MAX_TIMEOUT_VALUE = 1000 * 60 * 60 * 24;
const getPreAccessEndsIn = (timeLeftInMS) => timeLeftInMS < MAX_TIMEOUT_VALUE ? timeLeftInMS : MAX_TIMEOUT_VALUE;
const getPreAccessOnArticle = ({ preAccessEndDate, preAccessStartDate, preAccessGroups, userCustomerGroup, } = {}) => {
    if (!isPreAccessProduct({ preAccessGroups, preAccessEndDate, preAccessStartDate })) {
        return { shouldSetTimeout: false, isUserInUserGroup: false };
    }
    const isUserInUserGroup = isProductEnabledForUserGroup(preAccessGroups, userCustomerGroup);
    if (isUserInUserGroup) {
        const hasStartDatePassed = hasPreAccessEnded(preAccessStartDate);
        if (hasStartDatePassed) {
            return { isUserEligible: true };
        }
        const preAccessStartInMS = new Date(preAccessStartDate).getTime() - Date.now();
        return {
            isUserEligible: false,
            preAccessEndsInMS: getPreAccessEndsIn(preAccessStartInMS),
            shouldSetTimeout: true,
        };
    }
    const hasTimestampPassed = hasPreAccessEnded(preAccessEndDate);
    const preAccessEndsInMS = new Date(preAccessEndDate).getTime() - Date.now();
    const isUserEligible = hasTimestampPassed;
    const shouldSetTimeout = !isUserEligible && !hasTimestampPassed;
    return {
        shouldSetTimeout,
        isUserEligible,
        preAccessEndsInMS: getPreAccessEndsIn(preAccessEndsInMS),
    };
};
export default getPreAccessOnArticle;
//# sourceMappingURL=getPreAccessOnArticle.js.map